export default {
  title: '请选择',
  confirmText: '确定',
  cancelText: '取消',
};
